module.exports = __webpack_public_path__ + "static/media/icon_sales.b0bc36c7.svg";